import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { hulftPageMeta, hulftSchema } from 'components/common/schema'
import Template from 'components/cases/hulft'

const Hulft: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...hulftPageMeta} />
      <JsonLd data={hulftSchema} />
      <Template />
    </>
  )
}

export default Hulft
